import apiClient, { get, post, put } from "@/api/admin/client"
import type {
  AuthResponse,
  LoginRequest,
  RegisterRequest,
  TestPushRequest,
  User,
} from "@/api/shared/types"

export const login = async (data: LoginRequest): Promise<AuthResponse> => {
  return post<AuthResponse>("/auth/login", data)
}

export const register = async (data: RegisterRequest): Promise<{ message: string }> => {
  return post<{ message: string }>("/auth/register", data)
}

export const logout = async (): Promise<void> => {
  return post<void>("/auth/logout")
}

export const getCurrentUser = async (): Promise<User> => {
  return get<User>("/auth/profile")
}

export const updateProfile = async (data: Partial<User>): Promise<User> => {
  return put<User>("/auth/profile", data)
}

export const changePassword = async (data: {
  current_password: string
  new_password: string
}): Promise<{ message: string }> => {
  return post<{ message: string }>("/auth/change-password", data)
}

export const postTestPush = async (body?: TestPushRequest): Promise<{ message: string }> => {
  return post<{ message: string }>("/auth/test-push", body ?? {})
}

/** Unggah foto profil (multipart field `photo`). Pakai POST agar multipart stabil di browser/axios. */
export const uploadProfilePhoto = async (file: File): Promise<{ message: string; url: string }> => {
  const fd = new FormData()
  fd.append("photo", file, file.name)
  const { data } = await apiClient.post<{ message: string; url: string }>("/auth/profile/photo", fd)
  return data
}
